// Shared label class for the stream-date field (points-application + reservation dialogs).
export const FIELD_LABEL_CLASS = 'mb-1.5 block text-xs font-medium text-foreground';
// Min/max bounds for the stream date: from the drop's live date to live + reservation window.
export const streamDateBounds = (drop) => {
    const liveMs = drop.liveDate ? new Date(drop.liveDate).getTime() : NaN;
    if (Number.isNaN(liveMs)) {
        return { min: undefined, max: undefined };
    }
    return {
        min: new Date(liveMs),
        max: drop.pointsReservationHours ? new Date(liveMs + drop.pointsReservationHours * 3600000) : undefined,
    };
};
